import { hotelsEn } from './en'

export const hotelsEnCa = { ...hotelsEn }
